module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[115]236.6bc92ce.woff2";